"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStepDefinition = void 0;
const WidgetStepPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPlugin");
const WidgetStepPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPluginDefinition");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const InchcapeInternalEvents_1 = require("../../../../Enum/InchcapeInternalEvents");
const StepEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/StepEvents");
const EndpointError_1 = require("../../../../Error/EndpointError");
const ErrorCodes_1 = require("../../../../Enum/ErrorCodes");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const MyAccountRoutes_1 = require("../../../../Enum/MyAccountRoutes");
const InchcapeSelectorEvents_1 = require("../../Enum/InchcapeSelectorEvents");
const configs_1 = require("../../../../configs/configs");
const envConfig = require("../../../../configs/env-config");
// Step #5
class CustomerStep extends WidgetStepPlugin_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, repoFactory, assetManager) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper);
        this.valuationRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VALUATION, { config: this.widgetConfig });
        this.customerRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.CUSTOMER, { config: this.widgetConfig });
        this.assetManager = assetManager;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("factory.repository"), container.get("asset_manager"));
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.CUSTOMER).getTemplate();
    }
    /**
     * @inheritDoc
     */
    initialize() {
        this.state.setIsLoading(true);
        this.state.setBackButtonDisplay(true);
        return Promise.resolve()
            .then(() => this.assetManager.loadScript(configs_1.configs.externalWidgets.myAccount.react))
            .then(() => this.assetManager.loadScript(configs_1.configs.externalWidgets.myAccount.reactDom))
            .then(() => this.assetManager.loadScript(envConfig.REACT_APP_MY_ACCOUNT_BASE_WIDGET_URL));
    }
    /**
     * @inheritDoc
     */
    registerHandlers() {
        window.InchCapeWidgets.initialize({
            selector: `#${this.widgetConfig.getContainerId()}_auth`,
            widget: configs_1.configs.externalWidgets.myAccount.widget,
            basename: configs_1.configs.externalWidgets.myAccount.basename,
            language: configs_1.configs.dimensions.language,
            cookieDomain: this.widgetConfig.getCookieDomain(),
            browserRouter: false,
            events: {
                login: ((data) => {
                    this.handleLogin(data);
                }),
                is_logged: ((data) => {
                    this.handleIsLoggedIn(data);
                }),
                register: ((data) => {
                    this.handleRegister(data);
                }),
                route_changed: ((data) => {
                    this.handleReactRouteChange(data);
                }),
                error: ((data) => {
                    this.handleLoginError(data);
                })
            }
        });
    }
    handleLogin(data) {
        this.submit();
    }
    handleIsLoggedIn(data) {
        if (data.isLogged === true) {
            this.submit();
        }
        else {
            this.state.setIsLoading(false);
        }
    }
    handleRegister(data) {
        this.submit();
    }
    handleReactRouteChange(data) {
        if (data["route"] === MyAccountRoutes_1.MyAccountRoutes.FORGOT_PASSWORD) {
            this.state.setBackButtonDisplay(false);
        }
        else {
            this.state.setBackButtonDisplay(true);
        }
    }
    handleLoginError(data) {
        this.state.setIsLoading(false);
        this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, data.error);
    }
    /**
     * Updates valuation.
     *
     * @param valuation
     * @param reloadFromDataProvider
     * @return Promise<Valuation>
     */
    updateValuation(valuation, reloadFromDataProvider) {
        const oldCustomer = valuation.getCustomer();
        return this.valuationRepo.update(valuation, reloadFromDataProvider)
            .then((newValuation) => {
            const customer = newValuation.getCustomer();
            // @TODO: Remove BE validation.
            customer.setPrivacyPolicy(true);
            // Support for fast registered customer that has no postal code.
            customer.setPostalCode(customer.getPostalCode() || '1234');
            if (customer.getId()) {
                return this.customerRepo.update(customer, oldCustomer)
                    .then(() => newValuation);
            }
            return this.customerRepo.create(customer)
                .then((newCustomer) => {
                newValuation.setCustomer(newCustomer);
                return this.valuationRepo.update(newValuation);
            })
                .then((updatedValuation) => {
                // Set back the context because the second update removes it and
                // we need it in the exception flow.
                updatedValuation.setContext(newValuation.getContext());
                updatedValuation.setStatus(newValuation.getStatus());
                return updatedValuation;
            });
        })
            .then((newValuation) => {
            this.state.setCustomer(newValuation.getCustomer());
            this.state.setValuation(newValuation);
            this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.UPDATE_VALUATION, newValuation);
            return newValuation;
        });
    }
    /**
     * @inheritDoc
     */
    submit() {
        const valuation = this.state.getValuation();
        this.state.setIsLoading(true);
        return Promise.all([
            this.updateValuation(valuation, false),
            this.destroyMyAccountWidget(),
        ])
            .then(([newValuation]) => {
            this.eventContext.emit(StepEvents_1.StepEvents.STEP_FINISHED);
            return;
        })
            .catch((error) => {
            if (!EndpointError_1.default.is(error)) {
                this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
                return;
            }
            switch (error.getErrorCode()) {
                case ErrorCodes_1.ErrorCodes.OLD_VEHICLE:
                    this.state.setErrorCode(ErrorCodes_1.ErrorCodes.OLD_VEHICLE);
                    this.eventContext.emit(InchcapeInternalEvents_1.InchcapeInternalEvents.SET_STEP, StepTypes_1.StepTypes.EXCEPTION);
                    return true;
                    break;
                case ErrorCodes_1.ErrorCodes.NO_VALUATION:
                    this.state.setErrorMessage(error.getResponseMessage().split(":").pop());
                    this.eventContext.emit(InchcapeInternalEvents_1.InchcapeInternalEvents.SET_STEP, StepTypes_1.StepTypes.EXCEPTION);
                    return true;
                    break;
                default:
                    this.state.setErrorMessage(error.getResponseMessage());
            }
        })
            .then(() => {
            this.state.setIsLoading(false);
        });
    }
    /**
     * Destroys the login widget and removes the scripts.
     */
    destroyMyAccountWidget() {
        return Promise.resolve().then(() => {
            window.InchCapeWidgets.destroy(`#${this.widgetConfig.getContainerId()}_auth`);
        })
            .then(() => Promise.all([
            this.assetManager.removeScript(configs_1.configs.externalWidgets.myAccount.react),
            this.assetManager.removeScript(configs_1.configs.externalWidgets.myAccount.reactDom),
            this.assetManager.removeScript(envConfig.REACT_APP_MY_ACCOUNT_BASE_WIDGET_URL),
        ]));
    }
}
exports.default = CustomerStep;
exports.CustomerStepDefinition = new WidgetStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.CUSTOMER,
    class: CustomerStep,
    priority: 3400
});
